import riot from 'riot';
import events from '../src/events.js';
import { getSmartkits as libGetSmartkits, postDevices as libPostDevices, postDirectMethod as libPostDirectMethod } from '../src/lib.js';
riot.tag2('devices', '<div class="column is-12" style="margin-top: -75px;"> <div class="columns is-multiline" if="{!user}"> <div class="column is-12"> <article class="message is-warning is-light is-medium"> <div class="message-header"> <p>Please login to see your kits and sensors!</p> </div> <div class="message-body"> Once you login you will be able to register and manage your Filament kits and have tons of fun learning! </div> </article> </div> </div> <nav class="navbar" role="navigation" aria-label="main navigation" if="{user && !selectedDevice}" style="background-color: rgb(245,245,245);"> <div class="navbar-menu is-active"> <div class="navbar-start"> <div class="navbar-item"> <button class="button is-success" onclick="{toggleAddDevice}" if="{user}"> <span class="icon is-small"> <i class="fas fa-plus"></i> </span> <span>Register A Kit</span> </button> </div> </div> <div class="navbar-end"> <div class="navbar-item"> <button class="button is-warning" onclick="{refreshClick}"> <span class="icon is-small"> <i class="fas fa-sync"></i> </span> </button> </div> </div> </div> </nav> <div class="container is-fluid has-text-centered" show="{loading_smartkits}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> <div class="columns is-multiline" if="{user && !loading_smartkits && !selectedDevice && devices && devices.length==0}"> <div class="column is-12"> <article class="message is-info is-light is-medium"> <div class="message-header"> <p>Let\'s get you started!</p> </div> <div class="message-body"> If you have a Filament Kit, you can register it by clicking the green plus icon! If not, you can join a lesson with a lesson code on the Home tab! </div> </article> </div> </div> <div class="columns is-multiline" if="{user && !selectedDevice && adding_device}" style="margin-top: 5px;"> <div class="column is-12"> <div class="card"> <header class="card-header"> <p class="card-header-title"> Register a New Kit </p> </header> <div class="card-content"> <div class="content"> <div class="field is-grouped" style="margin-bottom: 1rem;"> <p class="control"> <button class="button is-info is-outlined is-small" onclick="{toggleInstructions}"> <span class="icon is-small"> <i class="fas fa-{showInstructions ? \'eye-slash\' : \'eye\'}"></i> </span> <span>{showInstructions ? \'Hide\' : \'Show\'} Quick Instructions</span> </button> </p> <p class="control"> <a class="button is-link is-outlined is-small" href="/support/filament_setup.html" target="_blank"> <span class="icon is-small"> <i class="fas fa-book"></i> </span> <span>Full Setup Guide</span> </a> </p> </div> <div if="{showInstructions}" style="margin-bottom: 1.5rem;"> <h3>Adding a new Filament is Quick and Easy!</h3> <ol> <li><b>Plug it in</b> — Use the provided cable and power adapter to connect your Filament kit to power.</li> <li><b>Connect to the Filament Wi-Fi</b> — On your device (computer, tablet, or phone), go to your Wi-Fi settings and select the network named filament-ID. The “ID” will match your Kit ID.</li> <li><b>Open the setup page</b> — Once connected, open a web browser and type 10.42.0.1 into the address bar.</li> <li><b>Link the kit to your Wi-Fi</b> — On the setup page, enter your home or office Wi-Fi name (SSID) and password, then click Save.</li> <li><b>Reconnect your device</b> — Go back to your device Wi-Fi settings and reconnect to your usual Wi-Fi network.</li> <li><b>Register your Filament</b> — Now, Enter the Kit ID and Name (any name you like), then click Register!</li> <li><b>Check if kit is online</b> — Once registered, click the refresh button (upper right of the card) to confirm it is connected.</li> </ol> <div class="notification is-info">Your Filament should now appear on the page and will indicate Online when connected!</div> </div> <div class="field has-addons"> <div class="control"> <a class="button is-static"> Name </a> </div> <div class="control is-expanded"> <input class="input" type="text" id="newDeviceName" placeholder="Enter A Name for Your Kit"> </div> </div> <div class="field has-addons"> <div class="control"> <a class="button is-static"> Device ID </a> </div> <div class="control is-expanded"> <input class="input" type="text" id="newDeviceId" placeholder="Enter The Kit ID"> </div> </div> <div class="field has-addons"> <div class="control"> <a class="button is-static"> Device Type </a> </div> <div class="control is-expanded" style="display: flex; align-items: center;"> <span class="tag is-info is-light is-medium" style="width: 100%; justify-content: flex-start; height: 2.5em;">Filament</span> </div> </div> <div class="field has-addons"> <div class="control"> <a class="button is-static"> Kit Type </a> </div> <div class="control is-expanded" style="display: flex; align-items: center;"> <span class="tag is-info is-light is-medium" style="width: 100%; justify-content: flex-start; height: 2.5em;">base</span> </div> </div> <div class="field is-grouped"> <p class="control"> <a class="button is-info" onclick="{addDeviceClick}"> Register </a> </p> <p class="control"> <a class="button is-light" onclick="{toggleAddDevice}"> Cancel </a> </p> </div> <article class="message is-danger is-light is-medium" if="{register_device_error}"> <div class="message-body"> {register_device_error} </div> </article> </div> </div> </div> </div> </div> <div class="columns is-multiline" if="{user && !loading_smartkits && !selectedDevice}" style="margin-top: 5px;"> <div class="column is-4" each="{d in devices}" if="{!devices_error}"> <div class="card"> <div class="card-content"> <div class="media"> <div class="media-left"> <figure class="image is-48x48"> <img if="{d.device_type==\'Filament\'}" src="img/brand/Filament_Logo_Mark_Navy.png" alt="Filament Icon"> <img if="{d.device_type!=\'Filament\'}" src="img/byod_device.png" alt="BYOD Icon"> </figure> </div> <div class="media-content"> <p class="title is-4">{d.device_name}</p> <p class="subtitle is-6">{d.device_id}</p> </div> <div class="media-right"> <button class="button is-loading" if="{loadingStatus[d.device_id]}"></button> <div class="tags has-addons" if="{loadingStatus[d.device_id]==false}"> <span class="tag is-medium is-{getStatusTag(d.status)}">{getStatusTagLabel(d.status)}</span> <a class="tag is-medium is-{getStatusTag(d.status)}" onclick="{refreshDeviceStatusClick}" style="text-decoration: none;"> <span class="icon is-small"> <i class="fas fa-sync"></i> </span> </a> </div> </div> </div> <div class="content"> <article class="message is-warning" style="margin-top: .75rem;"> <div class="message-header"> <p>Lessons In Progress</p> </div> <div class="message-body"> <div class="tags" if="{activities}"> <span class="tag is-info" each="{a in activities}" if="{a.device_ids.includes(d.device_id) && a.active}" onclick="{clickedActivityRef}">{a.activity_ref}</span> </div> <div class="container is-fluid has-text-centered" show="{!activities}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> </div> </article> <div class="buttons is-centered"> <button id="viewDetails" class="button is-primary" onclick="{selectDeviceClick}"> View Device Details </button> <button id="updateFirmware" class="button is-dark {loadingFirmwareUpdate[d.device_id] ? \'is-loading\' : \'\'}" onclick="{firmwareUpdateClick}" disabled="{loadingFirmwareUpdate[d.device_id] || !d.status}" title="{!d.status ? \'Device is offline\' : \'\'}"> <span class="icon is-small" if="{!loadingFirmwareUpdate[d.device_id]}"> <i class="fas fa-download"></i> </span> <span if="{!loadingFirmwareUpdate[d.device_id]}">Update Firmware</span> <span if="{loadingFirmwareUpdate[d.device_id]}">Updating...</span> </button> </div> <div class="notification is-warning" if="{d.updateStatus === \'initiating\'}" style="margin-top: 10px;"> <button class="delete" onclick="{closeFirmwareNotification}"></button> <p class="title is-6"> <span class="icon is-small"> <i class="fas fa-spinner fa-pulse"></i> </span> Initiating Firmware Update </p> <p>{d.updateMessage}</p> <progress class="progress is-warning" max="100"> Contacting device... </progress> </div> <div class="notification is-success" if="{d.updateStatus === \'success\'}" style="margin-top: 10px;"> <button class="delete" onclick="{closeFirmwareNotification}"></button> <p class="title is-6"> <span class="icon is-small"> <i class="fas fa-check-circle"></i> </span> Firmware Update Status </p> <p>{d.updateMessage}</p> </div> <div class="notification is-warning" if="{d.updateStatus === \'pending\'}" style="margin-top: 10px;"> <button class="delete" onclick="{closeFirmwareNotification}"></button> <p class="title is-6"> <span class="icon is-small"> <i class="fas fa-clock"></i> </span> Firmware Update In Progress </p> <p>{d.updateMessage}</p> <progress class="progress" max="100"> Rebooting device... </progress> </div> <div class="notification is-danger" if="{d.updateStatus === \'error\'}" style="margin-top: 10px;"> <button class="delete" onclick="{closeFirmwareNotification}"></button> <p class="title is-6"> <span class="icon is-small"> <i class="fas fa-exclamation-triangle"></i> </span> Firmware Update Failed </p> <p>{d.updateMessage}</p> </div> </div> </div> </div> </div> <div class="column is-12" if="{devices_error}"> <article class="message is-danger"> <div class="message-header"> <p>Oh No!</p> <button class="delete" aria-label="delete"></button> </div> <div class="message-body"> It looks like there was an error loading your kits! Try to refresh the page and if the problem persists, please check out status page to see if there are any ongoing issues. Thank you for you patience! <button class="button is-warning" onclick="{refreshClick}"> <span class="icon is-small"> <i class="fas fa-sync"></i> </span> <span>Refresh Kits</span> </button> </div> </article> </div> </div> <device-details if="{user && selectedDevice}"></device-details> </div>', '', '', function(opts) {
        var self = this;
        self.loading_smartkits = false;
        self.adding_device = false;
        self.showInstructions = false;
        self.editingName = false;
        self.selectedDevice = undefined;
        self.loadingStatus = {};
        self.loadingFirmwareUpdate = {};
        self.loadingResetWifi = {};
        self.devices_error = undefined;
        self.register_device_error = undefined;

        self.on('mount', function() {
            getUser();
            if (self.user) {
                getSmartkits();
            }
        });

        events.on('auth_complete', function() {
            self.user = 1;
            self.update();
        });

        events.on('users_loaded', function(user) {
            getUser();
            if (self.user) {
                getSmartkits();
            }
        });

        events.on('activities_loaded', function(activities) {
            self.activities = activities;
            self.update();
        });

        events.on('navigate_to_device', function(payload) {
            const { device_id, view, params } = payload || {};
            if (device_id && self.devices) {
                selDev = getLoadedDeviceById(device_id);
                if (selDev) {
                    self.selectedDevice = selDev;
                    self.update();
                    events.emit('select_device', { selectedDevice: selDev, view, params });
                } else {
                    console.warn("Device not found:", device_id);
                }
            } else if (self.devices) {
                self.unselectDevice();
            } else {

            }
        });

        events.on('navigate_to_devices_list', function() {
            self.selectedDevice = undefined;
            self.update();
        });

        events.on('devices_loaded', function(devices) {

            for (var i = 0; i < devices.length; i++) {
                self.loadingStatus[devices[i].device_id] = true;
                self.update();
                var data = {
                    "device": devices[i].device_id,
                    "method": "test",
                    "activity_ref": "test",
                    "activity_step": 1,
                    "measureType": "immediate"
                }
                postDirectMethod(data)
            }
        });

        this.getStatusTag = function(s) {
            if (s) {
                return "success"
            } else {
                return "danger"
            }
        }.bind(this)

        this.getStatusTagLabel = function(s) {
            if (s) {
                return "Online"
            } else {
                return "Offline"
            }
        }.bind(this)

        this.toggleAddDevice = function(e) {
            self.adding_device = !self.adding_device;
            self.register_device_error = undefined;
            self.showInstructions = false;
        }.bind(this)

        this.toggleInstructions = function(e) {
            self.showInstructions = !self.showInstructions;
            self.update();
        }.bind(this)

        this.addDeviceClick = function(e) {
            var dname = document.getElementById("newDeviceName").value;
            var did = document.getElementById("newDeviceId").value;

            var dtype = "Filament";
            var ktype = "base";

            postDevices({
                "device_name": dname,
                "device_id": did,
                "device_type": dtype,
                "kit_type": ktype
            })
        }.bind(this)

        this.refreshClick = function(e) {
            if (self.user) {
                getSmartkits()
            }
        }.bind(this)

        this.refreshDeviceStatusClick = function(e) {
            var refreshDevice = undefined;
            if (e && e.item && e.item.d) {
                refreshDevice = e.item.d;
            } else {
                refreshDevice = self.selectedDevice;
            }

            if (!refreshDevice) {
                return
            }
            self.loadingStatus[refreshDevice.device_id] = true;
            self.update();
            var data = {
                "device": refreshDevice.device_id,
                "method": "test",
                "activity_ref": "test",
                "activity_step": 1,
                "measureType": "immediate"
            }
            postDirectMethod(data)

        }.bind(this)

        this.firmwareUpdateClick = function(e) {
            var updateDevice = undefined;
            if (e && e.item && e.item.d) {
                updateDevice = e.item.d;
            } else {
                updateDevice = self.selectedDevice;
            }

            if (!updateDevice) {
                return;
            }

            self.loadingFirmwareUpdate[updateDevice.device_id] = true;

            updateDevice.updateStatus = 'initiating';
            updateDevice.updateMessage = 'Initiating firmware update...';
            self.update();

            var data = {
                "device": updateDevice.device_id,
                "method": "update_firmware",
                "activity_ref": "firmware_update",
                "activity_step": 1,
                "measureType": "immediate"
            };

            postDirectMethod(data, function(response) {
                console.log('Firmware update response:', response);

                self.loadingFirmwareUpdate[updateDevice.device_id] = false;

                if (response && response.data && Array.isArray(response.data)) {
                    var statusItem = response.data.find(item => item.type === 'firmware_update_status');
                    if (statusItem && statusItem.value === 'started') {
                        updateDevice.updateStatus = 'success';
                        updateDevice.updateMessage = 'Firmware Update Successful. Restarting Filament. Device will be back online in 1-2 minutes.';

                        setTimeout(function() {
                            if (self.selectedDevice && self.selectedDevice.device_id === updateDevice.device_id) {

                            }
                            updateDevice.updateStatus = null;
                            updateDevice.updateMessage = null;
                            self.update();
                        }, 180000);
                    } else {
                        updateDevice.updateStatus = 'error';
                        updateDevice.updateMessage = 'Firmware update failed - unexpected response';
                    }
                } else {
                    updateDevice.updateStatus = 'error';
                    updateDevice.updateMessage = response?.message || 'Firmware update failed';
                }
                self.update();
            });
        }.bind(this)

        this.selectDeviceClick = function(e) {

            routerHelpers.navigate('devices', e.item.d.device_id);
        }.bind(this)

        this.viewLessonsClick = function(e) {
            routerHelpers.navigate("lessons");
        }.bind(this)

        this.unselectDevice = function() {
            self.selectedDevice = undefined;
            routerHelpers.navigate("devices");
            self.update();
        }.bind(this)

        this.clickedActivityRef = function(e) {
            return

        }.bind(this)

        this.closeFirmwareNotification = function(e) {
            var device = e.item.d;
            if (device) {
                device.updateStatus = null;
                device.updateMessage = null;
                self.update();
            }
        }.bind(this)

        function update_device_status(device_id, status) {
            self.loadingStatus[device_id] = false;
            for (i = 0; i < self.devices.length; i++) {
                if (self.devices[i].device_id == device_id) {
                    self.devices[i].status = status;
                    self.update();
                    return
                }
            }
        }

        function getLoadedDeviceById(id) {
            for (i = 0; i < self.devices.length; i++) {
                if (self.devices[i].device_id == id) {
                    self.selectedDevice = self.devices[i];
                    return self.selectedDevice;
                }
            }
        }

        function getUser() {
            user_profile = localStorage.getItem('profile');
            if (user_profile != "undefined") {
                self.update({
                    user: JSON.parse(user_profile)
                });
            }
        };

        function getSmartkits() {
            self.loading_smartkits = true;
            libGetSmartkits().then(function(res) {
                self.loading_smartkits = false;

                if (!window.appData) {
                    window.appData = {};
                }

                window.appData.devices = res['data']['devices'];

                events.emit('devices_loaded', res['data']['devices']);

                self.update({
                    devices: res['data']['devices'],
                    devices_error: undefined
                });
            }).catch(function(error) {
                console.error('Smartkits Error:' + error);
                self.loading_smartkits = false;
                self.update({
                    devices: [],
                    devices_error: error
                });
            });
        }

        function postDevices(data) {
            self.loading_smartkits = true;
            libPostDevices(data).then(function(res) {
                self.loading_smartkits = false;
                self.register_device_error = undefined;
                getSmartkits();
            }).catch(function(error) {
                console.error('POST Devices Error:' + error);
                self.loading_smartkits = false;
                self.update({
                    register_device_error: error
                });
            });

        }

        function postDirectMethod(data, callback) {

            libPostDirectMethod(data).then(function(res) {
                update_device_status(data['device'], true)
                if (callback) {
                    callback(res);
                }
            }).catch(function(error) {
                console.log(data['device'] + " :: " + error)
                update_device_status(data['device'], false)
                if (callback) {
                    callback({success: false, msg: error.message || 'Network error'});
                }

            });
        }
});
